<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <template>
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="date" label="Tanggal Input">
                    <v-date-picker
                      mode="range"
                      id="date"
                      :input-props="{ class: 'form-control', placeholder: 'Tanggal Input', required: '', readonly: ''}"
                      v-model="myDate"
                    ></v-date-picker>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col lg="12" class="text-right">
                  <b-button
                    size="sm"
                    variant="stack-overflow"
                    class="mr-1 btn-brand"
                    @click="getListingAttendance"
                  >
                    <i class="fa fa-search"></i>
                    <span>Filter</span>
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="listAttendance"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="attendanceForm"
          :redirect-detail="false"
          :show-add-button="false"
          caption="<i class='fa fa-align-justify'></i> Driver Report"
          addButton="Tambah Employee"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>
      </b-col>
    </b-row>

    <b-modal
      ref="myModalRef"
      id="addModals"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">Driver Report</h3>
      </div>

      <div v-if="!loadingProcess">
        <b-form id="attendanceForm" validated novalidate>
          <b-row>
            <b-col lg="8">
              <b-row>
                <b-col lg="5">
                  <b-form-group label-for="name" label="Waktu Input">
                    <b-form-input
                      id="datetime"
                      type="text"
                      v-model="dateTimeFormat"
                      readonly
                      placeholder="Nama pemilik"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                
              </b-row>
              
              <b-row v-if="data">
                <b-col lg="5">
                  <b-form-group label-for="name" label="Nama Karyawan">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="data.employee_name"
                      readonly
                      placeholder="Nama pemilik"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col lg="5">
                  <b-form-group label-for="name" label="Total KM">
                    <b-form-input
                      id="total_km"
                      type="text"
                      v-model="data.total_km"
                      readonly
                      placeholder="Total KM"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              
             
              <b-row>
                <b-col lg="12">
                  <b-form-group label-for="name" label="Lokasi">
                    <GmapMap v-if="myLocation!=null"
                      :center="myLocation"
                      :zoom="10"
                      map-type-id="terrain"
                      style="height: 500px;"
                    >
                      <GmapMarker :key="0" :title="'asd'" :position="myLocation">
                        <GmapInfoWindow :options="{maxWidth: 300}" :position="myLocation" :opened="true">
                            <div>My Location</div>
                        </GmapInfoWindow>
                      </GmapMarker>

                      <GmapMarker :key="1" :title="'asd'" :position="myOfficeLocation">
                        <GmapInfoWindow :options="{maxWidth: 300}" :position="myOfficeLocation" :opened="true">
                              <div>{{myOfficeName}}</div>
                          </GmapInfoWindow>
                        </GmapMarker>
                    </GmapMap>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

            <b-col lg="4">
              <b-form-group label-for="name" label="Foto Selfie">
                <b-img :src="cleanUrl" :thumbnail="true" width="350"></b-img>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>
      <div v-else>
        <loading></loading>
      </div>

      <div slot="modal-footer" class="float-right">
       
         <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
          <i class="fa fa-undo"></i> Back
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import VueNotifications from "vue-notifications";
import { required, email } from "vuelidate/lib/validators";
import interfaces from "@/templates/_interfaces.js";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";
import globalTable from "@/templates/Table.vue";
import { gmapApi } from "vue2-google-maps";

export default {
  name: "driver-report",
  components: { ModelSelect, loading, globalTable },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      google: gmapApi,
      listAttendance: [],
      listVerified: [
        { value: "0", text: "Belum Terverifikasi" },
        { value: "1", text: "Valid" },
        { value: "2", text: "Tidak Valid" }
      ],
      data: null,
      myDate: {
        start: new Date(),
        end: new Date()
      },
      loading: false,
      attendanceForm: interfaces.driver_report,
      loadingProcess: false,
      fields: [
        {
          key: "employee_name",
          label: "Nama Karyawan",
          class: "",
          sortable: true
        },
        {
          key: "police_number",
          label: "Police Nummber",
          class: "",
          sortable: false
        },
        {
          key: "total_km",
          label: "Total KM",
          class: "",
          sortable: false
        },
        {
          key: "date_inserted",
          label: "Tanggal Insert",
          class: "",
          sortable: false
        },
        { key: "action", label: "Action", class: "width-50 text-center" }
      ]
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations: {
    attendanceForm: {
       employee_id: { },
        asset_car: { },
        total_km: { },  
        lat: { },  
        lng: { },
        attachment: { },
        date_inserted: { }

    }
  },
  computed: {
    cleanUrl: function() {
      if (this.data !== null) {
        if(this.data.attachment !== null) {
          let temp = "https://storage.googleapis.com/mbsstorage/"+ this.data.attachment;
          return temp;
          // let temp = this.data.picture.split(",");
          // return temp[0] + "," + temp[1];
        } else {
          return this.data.attachment;
        }
      } else {
        return null;
      }
    },
    dateTimeFormat: function() {
      if (this.data !== null) {
        return moment(this.data.date_inserted).format("DD MMM YYYY HH:mm:ss");
      } else {
        return null;
      }
    },
    myLocation: function() {
      if (this.data !== null) {
        return { lat: this.data.lat, lng: this.data.lng }
      } else {
        return null;
      }
    },
    myOfficeLocation: function() {
      if (this.data !== null) {
        return { lat: this.data.office_lat, lng: this.data.office_lng }
      } else {
        return null;
      }
    },
    myOfficeName: function() {
      if (this.data !== null) {
        return this.data.office_name;
      } else {
        return null;
      }
    }
  },
  methods: {
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    init: function() {
      this.getListingAttendance();
    },
    editForm: function(e) {
      this.isEdit = true;
      this.resetForm();
      this.attendanceForm = e;
      this.data = e;
    },
    resetForm: function() {
      for (var a in interfaces.driver_report) {
        interfaces.driver_report[a] = null;
      }
      this.data = null;
      this.attendanceForm = interfaces.driver_report;
    },
    saveProcess: function(evt, flag) {
      evt.preventDefault();
      if (confirm("Apakah karyawan ini sudah terverifikasi ?")) {
        this.loadingProcess = true;
        let data = this.attendanceForm;
        data.verified_by = localStorage.getItem("employee_id");
        data.id = this.data.id;
        data.flag = flag;
        this.axios
          .put("web/employee/verifikasi-attendance/", data)
          .then(response => {
            this.showInfoNotification({
              title: "Verifikasi karyawan",
              message: response.data.message
            });
          })
          .catch(error => {
            this.expired(error, "Verifikasi karyawan");
          })
          .finally(() => {
            this.loadingProcess = false;
            this.cancelAdd();
          });
      }

      //console.log(this.attendanceForm);
    },
    cancelAdd: function() {
      this.isEdit = false;
      this.data = null;
      this.$refs.myModalRef.hide();
      //this.init();
    },
    getListingAttendance: function() {
      let start = moment(this.myDate.start).format("YYYY-MM-DD");
      let end = moment(this.myDate.end).format("YYYY-MM-DD");
      this.loading = true;
      this.axios
        .get(
          "web/employee/driver-report/" +
            start +
            "/" +
            end +
            "/"
        )
        .then(response => {
          console.log(response.data.data)
          this.listAttendance = response.data.data;
        })
        .catch(error => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Verifikasi karyawan",
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>